// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToListModalStyles } from "@insite/content-library/Components/ManageShareListModal";
import { StyledButton } from "@insite/mobius/Clickable";
import { mergeWithCss, modalButtonsActionStyles, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

addToListModalStyles.userTableHeaderText = {
    color: "text.main",
};

addToListModalStyles.editingPermissionRadioGroup = {
    css: css`
        display: flex;
        width: 100%;
        justify-content: flex-start;
        flex-direction: row;
        padding-top: 10px;
        & > div {
            margin-top: 0 !important;
            margin-right: 20px;
            display: inline-flex;
        }
    `,
};

addToListModalStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            margin-top: 16px;
        `,
    }),
};
addToListModalStyles.userTable = {
    mergeCss: true,
    css: css`
        [class^="HeaderTypography"]:empty {
            display: none;
        }
    `,
};

addToListModalStyles.makePrivateButton = {
    ...modalButtonsActionStyles.cancelButton,
};

addToListModalStyles.closeButton = {
    ...modalButtonsActionStyles.submitButton,
};

addToListModalStyles.userCell = {
    ...mergeWithCss(addToListModalStyles.userCell, {
        css: css`
            &&& {
                ${xScreen("lte", "md")} {
                    justify-content: space-between;
                    & > ${StyledButton} {
                        margin-right: unset;
                    }
                }
                ${xScreen("lte", "xs")} {
                    p {
                        flex-basis: auto;
                    }
                }
            }
        `,
    }),
};
